import React from 'react';

import Box from '@material-ui/core/Box';
import {BoxProps, withStyles} from '@material-ui/core';
import {DISCRET_RANGE_PICKER_HEIGHT} from '../constants';

const DatePickerContainer = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        width: '100%',

        [theme.breakpoints.up('fmd')]: {
            minHeight: DISCRET_RANGE_PICKER_HEIGHT
        }
    }
}))(({children, ...props}: BoxProps) => <Box {...props}>{children}</Box>);

export default DatePickerContainer;
